import React from 'react';
import { Eye, RotateCcw, Archive, ArchiveRestore, BadgeCheck, Unlock } from 'lucide-react';
import { fmtDate, fmtEUR } from './api';

const STATUTS = {
  actif: { label: 'Actif', cls: 'bg-sky-100 text-sky-800' },
  archive: { label: 'Archivé', cls: 'bg-slate-100 text-slate-500' },
  definitif: { label: 'Définitif', cls: 'bg-emerald-600 text-white' },
};

const Action = ({ title, onClick, testId, children }) => (
  <button type="button" title={title} aria-label={title} onClick={(e) => { e.stopPropagation(); onClick(); }}
    className="p-1 rounded text-slate-500 hover:text-violet-700 hover:bg-violet-100 transition-colors" data-testid={testId}>
    {children}
  </button>
);

const VersionRow = ({ v, onAction }) => {
  const st = STATUTS[v.statut] || STATUTS.actif;
  const t = (a) => `ia-pack-v-${a}-${v.id}`;
  return (
    <li className={`rounded-md border px-2 py-1.5 ${v.statut === 'archive' ? 'border-slate-100 opacity-70' : 'border-violet-100 bg-white'}`} data-testid={`ia-pack-version-${v.id}`}>
      <div className="flex items-center justify-between gap-1">
        <span className="text-[11px] font-semibold text-slate-700">V{v.numero}</span>
        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${st.cls}`} data-testid={t('statut')}>{st.label}</span>
      </div>
      <p className="text-[10px] text-slate-500" data-testid={t('infos')}>
        {v.taux_final != null ? `${Number(v.taux_final).toFixed(2)} %` : '—'} · {fmtEUR(v.contribution_ttc)} TTC · {fmtDate(v.at)}
      </p>
      <div className="flex gap-0.5 mt-0.5">
        <Action title="Ouvrir le pack" onClick={() => onAction('ouvrir', v)} testId={t('ouvrir')}><Eye className="h-3.5 w-3.5" /></Action>
        <Action title="Recharger ce taux et ce montant" onClick={() => onAction('recharger', v)} testId={t('recharger')}><RotateCcw className="h-3.5 w-3.5" /></Action>
        <Action title={v.statut === 'archive' ? 'Restaurer' : 'Archiver pour modification'} onClick={() => onAction('archiver', v)} testId={t('archiver')}>
          {v.statut === 'archive' ? <ArchiveRestore className="h-3.5 w-3.5" /> : <Archive className="h-3.5 w-3.5" />}
        </Action>
        {v.statut !== 'definitif' ? (
          <Action title="Marquer comme souscription définitive" onClick={() => onAction('definitif', v)} testId={t('definitif')}><BadgeCheck className="h-3.5 w-3.5" /></Action>
        ) : (
          <Action title="Retirer le définitif" onClick={() => onAction('retirer-definitif', v)} testId={t('retirer-definitif')}><Unlock className="h-3.5 w-3.5" /></Action>
        )}
      </div>
    </li>
  );
};

export const PackVersions = ({ versions, onAction }) => {
  if (!versions?.length) return null;
  return (
    <div className="mt-2 space-y-1" data-testid="ia-pack-versions">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">Packs générés</p>
      <ul className="space-y-1">
        {[...versions].reverse().map((v) => <VersionRow key={v.id} v={v} onAction={onAction} />)}
      </ul>
    </div>
  );
};
